module.exports = __webpack_public_path__ + "static/media/modal-cadastro-pet-sucess-mobile.14d85d4d.png";